import { NgModule } from '@angular/core';
import { EventLongerThan60MinPipe, EventShorterThan60MinOrStartsAt2330Pipe } from './eventDuration.pipe';

@NgModule({
  declarations: [EventShorterThan60MinOrStartsAt2330Pipe, EventLongerThan60MinPipe],
  exports: [EventShorterThan60MinOrStartsAt2330Pipe, EventLongerThan60MinPipe],
})
export class EventDurationPipeModule {}
